import React from "react";
import { Hexagon, Linkedin, ArrowUpRight } from "lucide-react";
import { COMPANY } from "../data/content";

const columns = [
  {
    title: "Products",
    links: [
      { label: "AYOBELL Care", href: "#solutions" },
      { label: "AYOBELL HouseSpend", href: "#solutions" },
      { label: "SmartPosLite", href: "#solutions" },
      { label: "Feature Highlight", href: "#feature" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About Us", href: "#about" },
      { label: "Services", href: "#services" },
      { label: "Industries", href: "#industries" },
      { label: "Contact", href: "#contact" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", href: "#" },
      { label: "Terms", href: "#" },
      { label: "Cookies", href: "#" },
    ],
  },
];

const Footer = () => {
  return (
    <footer className="relative overflow-hidden bg-navy text-white" data-testid="site-footer">
      <div className="pointer-events-none absolute inset-0 grid-bg opacity-[0.06]" />
      <div className="relative mx-auto max-w-[1400px] px-6 py-20 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="relative flex h-9 w-9 items-center justify-center">
                <Hexagon className="h-9 w-9 text-teal" strokeWidth={1.5} />
                <span className="absolute h-2.5 w-2.5 rounded-full bg-teal" />
              </span>
              <span className="font-display text-lg font-bold">{COMPANY.legal}</span>
            </div>
            <p className="mt-5 max-w-sm text-sm text-white/60">{COMPANY.altTagline}</p>
            <p className="mt-4 text-sm text-white/50">{COMPANY.country}</p>
            <a
              href={COMPANY.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin"
              className="mt-6 inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/20 transition-colors hover:bg-white/10"
            >
              <Linkedin className="h-5 w-5" />
            </a>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-teal">{col.title}</h4>
              <ul className="mt-5 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="group inline-flex items-center gap-1 text-sm text-white/70 transition-colors hover:text-white"
                    >
                      {l.label}
                      <ArrowUpRight className="h-3.5 w-3.5 opacity-0 transition-opacity group-hover:opacity-100" />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-sm text-white/50 sm:flex-row">
          <p>© {new Date().getFullYear()} {COMPANY.legal}. All rights reserved.</p>
          <p>Serving the United Kingdom &amp; Nigeria</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
